import dayjs from "dayjs";
import { API_DATE_FORMAT } from "api/constants";

export const normalizeDate = (dateStr: string): string =>
  dayjs(dateStr).format(API_DATE_FORMAT);
